/* RESPONSIBLE TEAM: team-ai-insights */

import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type IntlService from 'embercom/services/intl';
import type { PulseAccordionSection } from 'glint/pulse';

interface Signature {
  Args: {
    section: PulseAccordionSection;
    sectionId: string;
  };
}

export default class SuggestionDataConnector extends Component<Signature> {
  @service declare intl: IntlService;
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::Automation::AiInsights::OptimizeSuggestions::Suggestions::SuggestionAccordionItems::SuggestionDataConnector': typeof SuggestionDataConnector;
    'reporting/automation/ai-insights/optimize-suggestions/suggestions/suggestion-accordion-items/suggestion-data-connector': typeof SuggestionDataConnector;
  }
}
